import service from "@/store/services/invoices-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  invoice: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, invoice) => {
    state.invoice = invoice;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((invoice) => {
      commit("SET_RESOURCE", invoice);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((invoice) => {
      commit("SET_RESOURCE", invoice);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((invoice) => {
      commit("SET_RESOURCE", invoice);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  send({ commit, dispatch }, params) {
    return service.send(params, this.$axios).then((invoice) => {
      commit("SET_RESOURCE", invoice);
    });
  },

  validate({ commit, dispatch }, params) {
    return service.validate(params, this.$axios).then((invoice) => {
      commit("SET_RESOURCE", invoice);
    });
  },

  cancel({ commit, dispatch }, params) {
    return service.cancel(params, this.$axios).then((invoice) => {
      commit("SET_RESOURCE", invoice);
    });
  },

  refund({ commit, dispatch }, params) {
    return service.refund(params, this.$axios).then((invoice) => {
      commit("SET_RESOURCE", invoice);
    });
  },

  applyPromoCode({ commit, dispatch }, params) {
    return service.applyPromoCode(params, this.$axios).then((invoice) => {
      commit("SET_RESOURCE", invoice);
    });
  },

  removePromoCode({ commit, dispatch }, params) {
    return service.removePromoCode(params, this.$axios).then((invoice) => {
      commit("SET_RESOURCE", invoice);
    });
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  invoice: (state) => state.invoice,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((invoice) => ({
      id: invoice.id,
      code: invoice.code,
    }));
  },
};

const invoices = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default invoices;
